import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../Button/index.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var Footer = function Footer(_ref) {
  var button = _ref.button,
      buttonClass = _ref.buttonClass;

  function renderButtons() {
    if (Array.isArray(button)) {
      return button.map(renderButton);
    } else if (button && button.action) {
      return renderButton(button);
    } else {
      return button;
    }
  }

  function renderButton(button, index) {
    var icon = button.icon,
        label = button.label;

    if (!icon && !label) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Button, _extends({
      key: index
    }, button, {
      onClick: button.action
    }));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: _formatClassName(['layout-footer', buttonClass])
  }, renderButtons());
};

Footer.displayName = "Footer";
Footer.propTypes = {
  button: PropTypes.oneOfType([PropTypes.shape(Button.propTypes), PropTypes.arrayOf(PropTypes.shape(Button.propTypes))]),
  buttonClass: PropTypes.string
};
export { Footer };